module.exports = __webpack_public_path__ + "static/media/gameOverSuccess.1d291782.jpg";